import { Pipe, PipeTransform } from '@angular/core';
import { Interval } from '@cco/model';
import { DateTime } from 'luxon';

export const MONTH_DAY_AND_SHORT_TIME: Intl.DateTimeFormatOptions = {
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  weekday: 'short',
};

export const DAY_OF_WEEK_AND_SHORT_TIME: Intl.DateTimeFormatOptions = {
  hour: 'numeric',
  minute: 'numeric',
  weekday: 'short',
};

@Pipe({
    name: 'lxInterval',
    standalone: true,
})
export class LuxonIntervalPipe implements PipeTransform {
  transform(value: Interval, format: Intl.DateTimeFormatOptions = MONTH_DAY_AND_SHORT_TIME, defaultValue = 'Unscheduled'): string {
    if (value == null || value.start == null || value.end == null)
      return defaultValue;

    const startDateTime = DateTime.fromISO(value.start);
    const endDateTime = DateTime.fromISO(value.end);
    if (!startDateTime.isValid || !endDateTime.isValid)
      return 'Invalid Interval';

    if (endDateTime.diff(startDateTime).toMillis() < 0)
      return 'Invalid Interval: start is after the end';

    return this.formatStart(startDateTime, format) + ' → ' + this.formatEnd(startDateTime, endDateTime);
  }

  formatStart(start: DateTime, format: Intl.DateTimeFormatOptions): string {
    return start.toLocaleString(format);
  }

  formatEnd(start: DateTime, end: DateTime): string {
    const localStart = start.toLocal();
    const localEnd = end.toLocal();

    if (localStart.year === localEnd.year && localStart.month === localEnd.month && localStart.day === localEnd.day)
      return end.toLocaleString(DateTime.TIME_SIMPLE);

    const dayDiff = localEnd.diff(localStart).shiftTo('days').days;

    if (dayDiff > 0)
      return '+' + Math.ceil(dayDiff) + ' ' + end.toLocaleString(DateTime.TIME_SIMPLE);
    else if (dayDiff < 0)
      return Math.floor(dayDiff) + ' ' + end.toLocaleString(DateTime.TIME_SIMPLE);
    else
      throw new Error('Unhandled scenario: unequal dates, but no day diff');
  }
}
